import React from "react";
import { Colors } from "../../Constants/colors";

export const WarningIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 2L2 20h20L12 2z"
      fill={Colors.TangerineOrange}
      fillOpacity="0.2"
    />
    <path
      d="M12 2L2 20h20L12 2z"
      stroke={Colors.TangerineOrange}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 9v4M12 17h.01"
      stroke={Colors.TangerineOrange}
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
